import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {IPricesAvailableDate} from "../types/IPricesAvailableDate";

export const pricesAvailableDateApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getPricesAvailableDate: builder.query<IPricesAvailableDate, void>({
            query: () => apiBigDataLink.currentDate.base(bigDataApiUrl)
        })
    }),
    overrideExisting: false
});

export const {useGetPricesAvailableDateQuery} = pricesAvailableDateApi;
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import {IPricesAvailableDate} from "../types/IPricesAvailableDate";

export const pricesAvailableDateApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getPricesAvailableDate: builder.query<IPricesAvailableDate, void>({
            query: () => apiBigDataLink.currentDate.base(bigDataApiUrl)
        })
    }),
    overrideExisting: false
});

export const {useGetPricesAvailableDateQuery} = pricesAvailableDateApi;
